import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Course } from '../courses/courses.model';
import { User } from '../users/users.model';
import { Role } from '../roles/roles.model';
import { Enrollment } from '../enrollments/enrollments.model';

export interface LaunchResponse {
  user: User ;
  course: Course ;
  role: Role ;
  enrollment: Enrollment ;
}

export interface OnetimeCodeResponse {
  code: string ;
}

@Injectable({
  providedIn: 'root'
})
export class LtiService {

  constructor(
    private http: HttpClient
  ) { 

  }

  public handleLaunch(ltik: string): Observable<LaunchResponse> {
    const url = `${environment.apiHost}/lti/launch?ltik=${ltik}`;
    return this.http.get<LaunchResponse>(url);
  }

  public getOnetimeCode(ltik: string): Observable<OnetimeCodeResponse> {
    const url = `${environment.apiHost}/lti/authcode?ltik=${ltik}`;
    return this.http.get<OnetimeCodeResponse>(url);
  }
}
